<template>
  <div class="field">
    <label class="mb-2 block"><strong>{{ titulo || 'SELECCIONE EXTRAS' }}</strong></label>
    <div v-if="cargando" class="flex align-items-center">
      <i class="pi pi-spin pi-spinner mr-2 text-primary"></i> Cargando extras...
    </div>
    <div v-else class="mt-2">
      <MultiSelect 
        v-model="seleccionados" 
        :options="extras" 
        optionLabel="nombre" 
        placeholder="Seleccione uno o más extras"
        display="chip"
        :maxSelectedLabels="20"
        filter
        class="w-full"
        @change="emitirCambio"
      >
        <template #option="slotProps">
          <div class="flex align-items-center">
            <span>{{ slotProps.option.nombre }}</span>
            <span v-if="slotProps.option.precio_venta > 0" class="text-green-600 font-bold ml-2">
              (Bs. {{ slotProps.option.precio_venta }})
            </span>
          </div>
        </template>
      </MultiSelect>

      <div v-if="extras.length === 0" class="text-500 font-italic mt-2">
        No hay Extras disponibles o activos.
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from '@/service/ProductService';

// Variables de caché a nivel de módulo para evitar múltiples peticiones en la misma sesión
let cachedExtras = null;
let fetchingExtrasPromise = null;

export default {
  name: 'CheckExtras',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    sucursalId: {
      type: [Number, String],
      default: 1
    },
    titulo: {
      type: String,
      default: 'SELECCIONE EXTRAS'
    }
  },
  data() {
    return {
      extras: [],
      seleccionados: [],
      cargando: false,
      productService: null
    };
  },
  created() {
    this.productService = new ProductService();
    this.seleccionados = [...this.modelValue];
  },
  mounted() {
    this.cargarExtras();
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.seleccionados = [...newVal];
      },
      deep: true
    },
    sucursalId() {
      // Si cambia de sucursal forzamos recarga
      cachedExtras = null;
      fetchingExtrasPromise = null;
      this.cargarExtras();
    }
  },
  methods: {
    cargarExtras() {
      if (cachedExtras) {
        this.extras = cachedExtras;
        return;
      }

      if (fetchingExtrasPromise) {
        this.cargando = true;
        fetchingExtrasPromise.then(extras => {
          this.extras = extras;
          this.cargando = false;
        });
        return;
      }

      this.cargando = true;
      fetchingExtrasPromise = this.productService.getExtras(this.sucursalId).then(response => {
        cachedExtras = response.extras || [];
        this.extras = cachedExtras;
        return cachedExtras;
      }).catch(err => {
        console.error("Error al cargar extras:", err);
        fetchingExtrasPromise = null;
        return [];
      }).finally(() => {
        this.cargando = false;
      });
    },
    emitirCambio() {
      this.$emit('update:modelValue', this.seleccionados);
      this.$emit('change', this.seleccionados);
    }
  }
}
</script>

<style scoped>
:deep(.p-multiselect-label) {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 4px;
  white-space: normal !important;
}
:deep(.p-multiselect-token) {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}
</style>

<style scoped>
</style>
